export const collectionFilterFilterable = {
  methods: {
    getUrlTagFilterParam() {
      this.urlFilterParam = new URL(window.location.href).searchParams.get(
        'tag'
      );
      if (this.urlFilterParam) {
        //checks filter param against product tags and returns true for a match
        this.products.forEach((prod) => {
          if (prod.tags.indexOf(this.urlFilterParam) > -1) {
            this.urlFilterMatch = true;
            return;
          }
        });
      }
    },
    //collectionHasGender(productArray, collectionTitle) {
    collectionHasGender(productArray) {
      // assume at first that there aren't men's or women's products
      var hasMens = false;
      var hasWomens = false;

      //if title contains gender {
      // if (collectionTitle.includes('men')){
      // 	hasMens = true
      // } else if (collectionTitle.includes('women')){
      // 	hasWomens = true
      // } else {

      // run through product array and check for men's and women's products
      productArray.forEach((product) => {
        if (product.tags.includes('men')) {
          hasMens = true;
        }
        if (product.tags.includes('women')) {
          hasWomens = true;
        }

        // can return early if both are true at this point
        if (hasMens && hasWomens) return true;
      });

      // end else
      //}

      return hasMens && hasWomens;
    },
    collectionHasCapacity(productArray) {
      for (let i = 0; i < productArray.length; i++) {
        if (
          productArray[i].tags.includes('< 10l') ||
          productArray[i].tags.includes('10 - 20l') ||
          productArray[i].tags.includes('20 - 30l') ||
          productArray[i].tags.includes('> 30l')
        ) {
          return true;
        }
      }
      return false;
    },
    createSizeFilterOptions(productArray) {
      let arr = [];
      productArray.forEach((p) => {
        p.colorways.forEach((c) => {
          c.sizes.forEach((s) => {
            //we don't want allpa only and such to make it into these options.
            if (
              s.slug === 'xxs' ||
              s.slug === 'xs' ||
              s.slug === 's' ||
              s.slug === 'm' ||
              s.slug === 'l' ||
              s.slug === 'xl' ||
              s.slug === 'xxl' ||
              s.slug === 'xxxl'
            ) {
              //check to see if we already have this size.
              if (!arr.some((e) => e.value === s.slug)) {
                arr.push({ text: s.name, value: s.slug });
              }
            }
          });
        });
      });
      //sort into small to large order
      arr.sort((a, b) => {
        return (
          this.sizeToNumberConverter(a.value) -
          this.sizeToNumberConverter(b.value)
        );
      });
      return arr;
    },
    sizeToNumberConverter(sizeSlug) {
      switch (sizeSlug.toLowerCase()) {
        case 'xxs':
          return 1;
          break;
        case 'xs':
          return 2;
          break;
        case 's':
          return 3;
          break;
        case 'm':
          return 4;
          break;
        case 'l':
          return 5;
          break;
        case 'xl':
          return 6;
          break;
        case 'xxl':
          return 7;
          break;
        case 'xxxl':
          return 8;
          break;
        default:
          return 9;
          break;
      }
    },
    // if tag exists
    tagExists(needle, haystack) {
      if (haystack.includes(needle)) {
        return true;
      }
      return false;
    },
    switchImages(color, img, product, isDelDia) {
      product.activeColor = color;
      if (isDelDia === false) {
        product.featuredImage = img;
      }
      product.isDelDia = isDelDia;
      this.$forceUpdate(); //this is used to get images to swap when the del dia color swatch is clicked.
    },
  },
};
